import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { get } from 'lodash';
import UpdateFeesModal from '../modals/UpdateFeesModal';

function FinalFeesInformation({ permitId, data, applicationInfo, isApproved }) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleUpdateFees = (info) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateFeesModal feeData={info} permitId={permitId} />,
      title: 'Update Fee',
      modalSize: 'modal-md',
    });
  };

  const quarter = (period) => {
    if (period === 1) return '1 QTR';
    if (period === 2) return '2 QTR';
    if (period === 3) return '3 QTR';
    if (period === 4) return '4 QTR';
    return '';
  };

  return (
    <div className="p-3">
      <div style={{overflowX: 'auto'}}>
        <table className="transaction-table table table-bordered table-sm">
          <thead>
            <tr>
              <th>Description</th>
              <th className="text-center">Amount</th>
              <th className="text-center">Discount</th>
              <th className="text-center">Interest</th>
              <th className="text-center">Surcharge</th>
              <th className="text-center">Total</th>
              <th className="text-center">Year</th>
              <th className="text-center">Period</th>
              {Acl(permissions, ['UPDATE BPLS BILLING']) &&
                get(applicationInfo, 'attributes.status') === 'COMPUTED' &&
                !isApproved && <th className="text-center">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <React.Fragment>
                  <tr key={item.id}>
                    <td>
                      <h5>
                        {get(item, 'attributes.code') || '-'} -{' '}
                        {get(item, 'attributes.description') || '-'}
                      </h5>
                    </td>
                    <td className="text-right">
                      <h5>
                        {get(item, 'attributes.amount_human') || '-'}
                      </h5>
                    </td>
                    <td className="text-right">
                      <h5>
                        {get(item, 'attributes.discount_human') || '-'}
                      </h5>
                    </td>
                    <td className="text-right">
                      <h5>
                        {get(item, 'attributes.penalty_human') || '-'}
                      </h5>
                    </td>
                    <td className="text-right">
                      <h5>
                        {get(item, 'attributes.surcharge_human') || '-'}
                      </h5>
                    </td>
                    <td className="text-right">
                      <h5>
                        {get(item, 'attributes.total_human') || '-'}
                      </h5>
                    </td>
                    <td className="text-center text-sm">
                      <h5>
                        {get(item, 'attributes.year') || '-'}
                      </h5>
                    </td>
                    <td className="text-center">
                      <h5>
                        {get(item, 'attributes.qtr_from') || '-'}-
                        {quarter(get(item, 'attributes.qtr_to')) || ''}
                      </h5>
                    </td>
                    {Acl(permissions, ['UPDATE BPLS BILLING']) && !isApproved && (
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items-center">
                          <button
                            onClick={handleUpdateFees(item)}
                            type="button"
                            className="btn-blank btn-sm"
                          >
                            <i className="far fa-edit icon-edit" />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              );
            })}
            <tr>
              <td colSpan={4} />
              <td><h5>Total</h5></td>
              <td className="text-right">
                <h5>
                  {get(applicationInfo, 'attributes.total_human', '0.00')}
                </h5>
              </td>
              <td colSpan={2} />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

FinalFeesInformation.defaultProps = {
  permitId: '',
  applicationInfo: {},
  isApproved: false,
};

FinalFeesInformation.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  permitId: PropTypes.string,
  applicationInfo: PropTypes.instanceOf(Object),
  isApproved: PropTypes.bool,
};

export default FinalFeesInformation;
